import { Link } from "react-router-dom";
import { fmtD } from "@/lib/api";
import { cn } from "@/lib/utils";

const tone = (r) => (r >= 4 ? "bg-emerald-600" : r >= 3 ? "bg-amber-500" : "bg-rose-600");

export function HygieneRating({ data, compact = false, linked = false, testid = "hygiene-rating-badge" }) {
  if (!data) {
    if (compact) return null;
    return (
      <div data-testid={`${testid}-empty`} className="flex items-center gap-3 rounded-2xl border border-dashed border-slate-300 px-4 py-3 text-xs text-slate-500">
        <span className="font-display text-2xl font-extrabold text-slate-300">–</span>
        <span>No inspector rating yet. Share your records from Records &amp; calendar.</span>
      </div>
    );
  }
  if (compact) {
    return <span data-testid={testid} title={`${data.name}, ${fmtD(data.at)}`} className={cn("rounded-full px-2 py-0.5 text-[11px] font-bold text-white", tone(data.rating))}>Inspector {data.rating}/5</span>;
  }
  const Wrap = linked ? Link : "div";
  return (
    <Wrap {...(linked ? { to: "/app/records", title: "See rating history" } : {})} data-testid={testid} className="flex items-center gap-3 rounded-2xl bg-slate-900 px-4 py-3 text-white transition-colors duration-150 hover:bg-slate-800">
      <span className={cn("flex h-12 w-12 shrink-0 items-center justify-center rounded-full font-display text-2xl font-extrabold", tone(data.rating))}>{data.rating}</span>
      <span className="min-w-0">
        <span className="block font-mono text-[10px] uppercase tracking-wider text-emerald-300">Inspector rating · out of 5</span>
        <span className="block truncate text-xs text-slate-300">{data.name} · {fmtD(data.at)}</span>
      </span>
    </Wrap>
  );
}
